module.exports = __webpack_public_path__ + "img/2024-12-12a_3.cf5cc80e.jpg";